<template>
    <div class="posts-wrapper">
        <div class="all-posts-container">
            <PinnedPostsWidget
                :pinnedPosts="pinnedPosts"
                :isOwnStorefront="isOwnStorefront"
            />
            <div v-if="!posts.length" class="text-center">
                This pro has no posts.
            </div>
            <Post
                :includeComments="false"
                v-for="post in posts"
                :key="post.id"
                :post="post"
                :user="{}"
                :includePin="isOwnStorefront"
            />
        </div>
    </div>
</template>

<script>
import PinnedPostsWidget from "./PinnedPostsWidget.vue";
import Post from "../../Utils/Post.vue";
export default {
    // TODO: loop through and display posts
    props: ["posts", "pinnedPosts", "isOwnStorefront"],
    components: {
        PinnedPostsWidget,
        Post,
    },
};
</script>

<style scoped>
::-webkit-scrollbar {
    width: 10px;
}

::-webkit-scrollbar-thumb {
    background-clip: padding-box;
    border-radius: 10px;
}

::-webkit-scrollbar-track {
    width: 10px;
    border-radius: 10px;
}
</style>
